export const currentTimeInMillis = (): number => {
  return new Date().getTime();
};
